// The leaderboard's profit text and each sort's podium stat.

import { formatROI } from './formatting';
import type { LeaderboardStats, SortBy } from './hooks/useLeaderboard';

/** A profit in whole dollars with its sign, as the board and the podiums print it: `$+340`, `$-25`. */
export function formatProfit(amount: number): string {
  return `$${amount >= 0 ? '+' : ''}${amount.toFixed(0)}`;
}

// The podium's headline stat for the active sort; null for a profit hidden from this viewer, which
// the podium draws as its hidden marker.
export function formatPodiumStat(stats: LeaderboardStats, sortBy: SortBy): string | null {
  switch (sortBy) {
    case 'roi':
    case 'rawRoi':
      return formatROI(stats.roi);
    case 'profit':
      return stats.totalProfit === null ? null : formatProfit(stats.totalProfit);
    case 'streak':
      return `${stats.currentStreak >= 0 ? '+' : ''}${stats.currentStreak}`;
    default:
      return `${stats.winRate.toFixed(1)}%`;
  }
}
